
import React from 'react';
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from "@/components/ui/select";
import { TimePeriod } from "@/utils/dashboardUtils";

interface TimeRangeSelectorProps {
  value: TimePeriod;
  onValueChange: (value: TimePeriod) => void;
}

const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({ value, onValueChange }) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 justify-end">
      <div className="flex items-center gap-2">
        <label htmlFor="period" className="font-medium min-w-max text-muted-foreground text-sm">
          Period:
        </label>
        <Select value={value} onValueChange={v => onValueChange(v as TimePeriod)}>
          <SelectTrigger className="w-32">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="day">Day</SelectItem>
            <SelectItem value="week">Week</SelectItem>
            <SelectItem value="month">Month</SelectItem>
            <SelectItem value="year">Year</SelectItem>
            <SelectItem value="all">All Time</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default TimeRangeSelector;
